<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.about}} Knowvation</h3>
</div>
<div class="modal-body">
	<ul class="list-unstyled">
	  <li>{{LOCALIZATION.knowvation}} {{LOCALIZATION.version}}: {{version.build}}</li>
	  <li>{{LOCALIZATION.knowvation}} {{LOCALIZATION.buildDate}}: {{version.buildDate}}</li>
	  <li>{{LOCALIZATION.ui}}: {{version.uiName}}</li>
	  <li>{{LOCALIZATION.ui}} {{LOCALIZATION.version}}: {{version.uiBuild}}</li>
	</ul>	
	<div>{{LOCALIZATION.copyright}}</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>